// extracted by mini-css-extract-plugin
module.exports = {"testimonials":"TestimonialsSection_testimonials__7XwTa","testimonialsContent":"TestimonialsSection_testimonialsContent__7k76q"};